import { isVisible } from 'utils/is_visible'

window.htmxFilters = {
  billingReadyToSubmit() {
    const stripeTokenPresent = document.getElementById("stripeToken") !== null
    const stripeFields = document.querySelector("[data-js-stripe-card-fields]")
    const stripeFieldsVisible = stripeFields && isVisible(stripeFields)

    return stripeTokenPresent || !stripeFieldsVisible
  }
}
